const ctDisplaySetSelector = {
	seriesMatchingRules: [
		{
			attribute: 'Modality',
			constraint: {
				equals: {
					value: 'CT'
				}
			},
			required: true
		},
		{
			attribute: 'isReconstructable',
			constraint: {
				equals: {
					value: true
				}
			},
			required: true
		},
		{
			attribute: 'SeriesDescription',
			constraint: {
				contains: 'CT'
			}
		},
		{
			attribute: 'SeriesDescription',
			constraint: {
				contains: 'CT WB'
			}
		}
	]
};

const ptDisplaySetSelector = {
	seriesMatchingRules: [
		{
			attribute: 'Modality',
			constraint: {
				inclusion: ['PT', 'NM']
			},
			required: true
		},
		{
			attribute: 'isReconstructable',
			constraint: {
				equals: {
					value: true
				}
			},
			required: true
		},
		{
			attribute: 'SeriesDescription',
			constraint: {
				contains: 'Corrected'
			}
		},
		{
			weight: 2,
			attribute: 'SeriesDescription',
			constraint: {
				doesNotContain: {
					value: 'Uncorrected'
				}
			}
		}
	]
};

export { ctDisplaySetSelector, ptDisplaySetSelector };
